<template>
  <button
      type="button"
      class="feature-remove-image"
      title="حذف عکس"
      @click.stop="removeFeatureImage()">
    <b-icon-trash/>
  </button>
</template>

<script>
import {checkValueIsNumber} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'

export default {
  name: "FeatureRemoveImageButton",
  props: {
    productFeature: {}
  },
  methods: {
    clearLocalImage() {
      this.productFeature.image = null
      this.productFeature.preview = null
      if (this.productFeature.featureImage != undefined) {
        this.productFeature.featureImage = null
      }
    },
    removeFeatureImage() {
      if (!confirm("آیا از حذف عکس اطمینان دارید؟")) {
        return
      }

      const isSaved = checkValueIsNumber(this.productFeature.id)
      if (!isSaved) {
        this.clearLocalImage()
        return
      }

      const form = {
        feature_product_id: this.productFeature.id
      }
      this.$store.dispatch('Product/deleteProductFeatureImage', form)
          .then(() => {
            this.clearLocalImage()
          })
    }
  }
}
</script>

<style scoped>
.feature-remove-image {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 10px;
  background: rgba(30, 30, 30, 0.78);
  color: #fff;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(30, 30, 30, 0.22);
}

.feature-remove-image:hover {
  background: #dc2530;
}
</style>
